import { render, staticRenderFns } from "./CmgNutritionCalculatorMealBuilder.vue?vue&type=template&id=21203716&scoped=true&lang=pug&"
import script from "./cmg-nutrition-calculator-meal-builder.ts?vue&type=script&lang=ts&"
export * from "./cmg-nutrition-calculator-meal-builder.ts?vue&type=script&lang=ts&"
import style0 from "./CmgNutritionCalculatorMealBuilder.vue?vue&type=style&index=0&id=21203716&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21203716",
  null
  
)

export default component.exports